import { Text, FocusTrap } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import EmpresaForm from "../../components/empresa-form";
import { TEmpresaForm } from "../../firestore";

const EmpresaFormModal = ({ context, innerProps, id }: ContextModalProps<{ item: TEmpresaForm }>) => {
  const { item: empresa } = innerProps;
  /**
   * Handle add ignore area success
   */
  function onSuccess() {
    context.closeModal(id);
  }

  return (
    <FocusTrap active={true}>
      <Text fw="bold" mb="md">
        Cadastro de empresa
      </Text>
      <EmpresaForm empresa={empresa} onSuccess={onSuccess} />
    </FocusTrap>
  );
};

export default EmpresaFormModal;
